export default __webpack_public_path__ + "static/media/clio-rs-colour-4.251d8066.jpg";